import { Tag } from 'm-ui';
import React, { FC, useEffect, useState } from 'react';
import './index.less';

const { CheckableTag } = Tag;
interface ICatagaryKeyValue {
  id: number;
  value: string;
}
interface ICatagaryLineProps {
  defaultValue?: number | null;
  value?: number;
  title: string;
  list: ICatagaryKeyValue[];
  onChange?: (key: number) => void;
}
const CategoryLine: FC<ICatagaryLineProps> = (props) => {
  const { list, onChange, title, defaultValue, value } = props;
  const [selectedTag, setSelectedTag] = useState<number | undefined>(defaultValue ?? undefined);
  const handleChange = (tag: number, checked: any) => {
    onChange?.(tag);
    setSelectedTag(tag);
  };
  useEffect(() => {
    setSelectedTag(value);
  }, [value]);
  return (
    <div className="catagary-line">
      <div className="cl-title">{title}</div>
      <div className="cl-tags">
        {list.map((tag) => (
          <CheckableTag
            key={tag.id}
            checked={selectedTag === tag.id}
            onChange={(checked: any) => handleChange(tag.id, checked)}
          >
            {tag.value}
          </CheckableTag>
        ))}
      </div>
    </div>
  );
};

export default CategoryLine;
